/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} State_PlayingInputs */



/**
* | output |
* | --- |
* | "Playing" |
*
* @param {State_PlayingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const state_playing = /** @type {((inputs?: State_PlayingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<State_PlayingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En cours")
	if (locale === "es") return /** @type {LocalizedString} */ ("En juego")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Em jogo")
	if (locale === "it") return /** @type {LocalizedString} */ ("In gioco")
	return /** @type {LocalizedString} */ ("Playing")
});